module.exports = __webpack_public_path__ + "categories/icon-feature-payment-c1c9509f80d69a6de990a17182e6c8ef.svg";